"use client";

/**
 * MobileContainer — 모바일 웹뷰용 뷰포트 컨테이너
 *
 * 루트 layout.tsx 에서 감싸면 로그인 페이지를 포함한 모든 페이지가
 * 모바일 너비로 제한된다. AdminLayout 과 별개로 동작하므로 함께 사용할 수 있다.
 *
 * @example
 * // app/layout.tsx
 * import { MobileContainer } from "@sunkim4638/admin-modules";
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         <MobileContainer>{children}</MobileContainer>
 *       </body>
 *     </html>
 *   );
 * }
 *
 * // app/(admin)/layout.tsx
 * import { AdminLayout } from "@sunkim4638/admin-modules";
 *
 * export default function AdminLayoutWrapper({ children }) {
 *   return (
 *     <AdminLayout type="mobile" nav={nav} ...>
 *       {children}
 *     </AdminLayout>
 *   );
 * }
 */
import type { CSSProperties, ReactNode } from "react";

import { cn } from "../../lib/utils";

export interface MobileContainerProps {
  children: ReactNode;
  /** 최대 너비 (px 또는 CSS 값). 기본 430px */
  maxWidth?: number | string;
  className?: string;
}

export function MobileContainer({
  children,
  maxWidth = 430,
  className,
}: MobileContainerProps) {
  const style: CSSProperties =
    typeof maxWidth === "number"
      ? { maxWidth: `${maxWidth}px` }
      : { maxWidth };

  return (
    <div
      className={cn("relative mx-auto min-h-screen w-full", className)}
      style={style}
    >
      {children}
    </div>
  );
}
